export const isHtml = (body: string) => /<\/?[a-z][\s\S]*>/i.test(body);